import * as types from './mutation-types'

// importamos los servicios api
import { getHome } from '@/api/Home.js'

// accion para cambiar data modalidad
export const setHome = ({ commit }, data) => {
  commit(types.SET_HOME, data)
}

// ACCION PARA LISTAR CATEGORIAS
export const cargarHome = ({ commit }) => {
  commit(types.LOAD_HOME)
  // realizamos la consulta al servidor
  getHome().then(
    (response) => {
      // se cargo correctamente
      commit(types.SET_HOME, response.data)
    }
  ).catch(
    () => {
      // fallo la consulta ponemos la lista em vacio
      commit(types.SET_HOME, null)
    }
  )
}
